import { createClient } from '@supabase/supabase-js';

// These are public, client-safe values (the anon key is meant to ship to the
// browser; Row Level Security in Postgres is what actually protects the data).
// They are injected at build time by Netlify. See ADMIN_SETUP.md.
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Surface a clear console message instead of a cryptic crash if the env vars
// were never configured in Netlify.
export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

if (!isSupabaseConfigured) {
  // eslint-disable-next-line no-console
  console.warn(
    '[MC Movers] Supabase env vars missing. Set REACT_APP_SUPABASE_URL and ' +
      'REACT_APP_SUPABASE_ANON_KEY in Netlify. The staff console will not work until then.'
  );
}

export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-anon-key',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
    },
  }
);
